import { Drawer, Box, Tooltip, Select, MenuItem, CircularProgress } from '@mui/material';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { useState, useEffect, useRef } from 'react'

import IconButton from "@mui/material/IconButton";
import { Badge, AppBar, Toolbar, Typography, TextField, FormGroup, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { NLIApi,ScholtenNegativesData,ScholtenPrintsData } from '../api.js'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import InputIcon from '@mui/icons-material/Input';
import SquareLoader from 'react-spinners/SquareLoader';
import { addItem } from '../supabaseApi';
import { supabase } from '../supabase';
import { iiifUrl } from '../supabase';
import { NLI } from '../utils/conversionDict.js'
import { css } from "@emotion/react";
import HoverPreview from './hoverPreview';
import { accent } from '../utils/colorDict';

const ExternalPreviewModal = ({ open, onClose, item }) => {
  if (!open || !item) return null;
  return (
    <div onClick={onClose} style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        maxWidth: '80vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', cursor: 'default'
      }}>
        <img
          src={item.modalUrl}
          alt=""
          style={{ maxWidth: '80vw', maxHeight: '75vh', objectFit: 'contain', borderRadius: 4 }}
        />
        <Typography variant="body1" sx={{ color: 'white', mt: 1, textAlign: 'center', maxWidth: '60vw' }}>
          {item.title}
        </Typography>
        {item.externalId && (
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', mt: 0.5 }}>
            ID: {item.externalId}
          </Typography>
        )}
      </div>
    </div>
  );
};

const ExternalWidget = ({ mapRef, rightPanel, handleModalData, handleRightPanel,authData }) => {
  //const keysToDrop = ['Language','Country']  
  const [inputString, setInputString] = useState('')
  const [index, setIndex] = useState(0)
  const [apiData, setApiData] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadedImgs, setLoadedImgs] = useState([])
  const [headerUrls, setHeaderUrls] = useState([])
  const [importedUrls, setImportedUrls] = useState([])
  const [searchType, setSearchType] = useState('label')
  const [apiIndex,setApiIndex] = useState('ScholtenNegatives')
  const [existingIds, setExistingIds] = useState(new Set())
  const [previewItem, setPreviewItem] = useState(null)
  const scrollRef = useRef(null)

  let skip = 20

  useEffect(() => {
    if (rightPanel !== 6) return;
    supabase.from('media_items').select('external_id').not('external_id', 'is', null).limit(10000)
      .then(({ data }) => {
        if (data) {
          console.log('Loaded', data.length, 'existing external IDs');
          setExistingIds(new Set(data.map(d => d.external_id)));
        }
      });
  }, [rightPanel])

  const currentBatch = Math.floor(index / skip);
  const totalBatches = Math.max(1, Math.ceil(headerUrls.length / skip));

  const Pagination = () => headerUrls.length ? (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '4px 0' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
      <IconButton
        size="small"
        style={{ color: accent }}
        disabled={currentBatch === 0}
        onClick={() => setIndex(i => Math.max(0, i - skip))}
      >
        <ArrowLeftIcon />
      </IconButton>
      <Select size="small" value={currentBatch} onChange={(e) => setIndex(e.target.value * skip)}
        sx={{ minWidth: 60, fontSize: '0.85rem', '& .MuiSelect-select': { py: '2px' } }}>
        {Array.from({ length: totalBatches }, (_, i) => (
          <MenuItem key={i} value={i}>{i + 1}</MenuItem>
        ))}
      </Select>
      <Typography variant="caption" color="text.secondary">/ {totalBatches}</Typography>
      <IconButton
        size="small"
        style={{ color: accent }}
        disabled={currentBatch >= totalBatches - 1}
        onClick={() => setIndex(i => Math.min(i + skip, (totalBatches - 1) * skip))}
      >
        <ArrowRightIcon />
      </IconButton>
    </div>
    <Typography variant="caption" color="text.secondary">
      Items {index + 1}–{Math.min(index + skip, headerUrls.length)} of {headerUrls.length}
    </Typography>
    </div>
  ) : null
  
  const [searched, setSearched] = useState(false)

  const handleExternalSearch = async () => {
    setLoading(true)
    setLoadedImgs([])
    setApiData([])
    setSearched(false)

    // Fetch ALL existing external IDs (Supabase caps at 1000 per request)
    let allIds = [];
    let from = 0;
    const pageSize = 1000;
    while (true) {
      const { data: page } = await supabase
        .from('media_items').select('external_id').not('external_id', 'is', null)
        .range(from, from + pageSize - 1);
      if (!page || page.length === 0) break;
      allIds = allIds.concat(page.map(d => d.external_id));
      if (page.length < pageSize) break;
      from += pageSize;
    }
    const imported = new Set(allIds);
    setExistingIds(imported);

    const source = apiIndex === 'ScholtenNegatives' ? ScholtenNegativesData
                 : apiIndex === 'ScholtenPrints' ? ScholtenPrintsData
                 : null;

    if (source) {
      const isExact = (inputString.startsWith('"') && inputString.endsWith('"')) ||
                      (inputString.startsWith("'") && inputString.endsWith("'"));
      const cleanQuery = isExact ? inputString.slice(1, -1).toLowerCase() : inputString.toLowerCase();
      const words = isExact ? null : cleanQuery.split(/\s+/).filter(w => w.length > 0);

      const res = source.filter(item => {
        const idMatch = item['@id'].match(/item:(\d+)/);
        const externalId = idMatch ? idMatch[1] : null;
        if (externalId && imported.has(externalId)) return false;
        const label = item.label.toLowerCase();
        const id = item['@id'].toLowerCase();
        if (isExact) {
          return label.includes(cleanQuery) || id.includes(cleanQuery);
        } else {
          // All words must match (AND logic)
          return words.every(w => label.includes(w) || id.includes(w));
        }
      });
      setHeaderUrls(res);
      setSearched(true);
    }


  }

  useEffect(() => {
    if (!headerUrls.length) { setApiData([]); setLoading(false); return; }

    const items = headerUrls.slice(index, index + skip).map(item => {
      const idMatch = item['@id'].match(/item:(\d+)/);
      const externalId = idMatch ? idMatch[1] : null;
      return {
        meta: [{ label: 'Title', value: item.label }],
        imageUrl: iiifUrl(externalId, 4),
        externalId
      };
    });

    setApiData(items);
    setLoading(false);
    scrollRef.current?.scrollIntoView({ behavior: 'instant', block: 'start' });
  }, [headerUrls, index])

  return <><Drawer
    PaperProps={{ style: { height: 'calc(100% - 80px)', top: '80px', zIndex: 3, width: '34vw', overflowX: 'hidden', background: 'whitesmoke', padding: '10px' } }}
    variant="persistent"
    anchor={'left'}
    onClose={() => { handleRightPanel(0) }}
    open={rightPanel === 6}
  >

 <form onSubmit={(e) => {
  setIndex(0)
  e.preventDefault();
  if (!inputString.length) { return }
  handleExternalSearch(inputString)
}}
style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', alignItems: 'center' }}
>
  <div />
  <Select style={{ margin: '4px 0', minWidth: 0 }}
    onChange={(e)=>{setApiIndex(e.target.value)}}
    value={apiIndex}
    size="small"
  >
    <MenuItem value={'ScholtenNegatives'}>Leiden University Libraries: Frank Scholten Legacy (Negatives)</MenuItem>
    <MenuItem value={'ScholtenPrints'}>Leiden University Libraries: Frank Scholten Legacy (Prints)</MenuItem>
  </Select>
  <div />

  <Button type="submit" color="inherit"><SearchIcon /></Button>
  <TextField
    autoComplete='off'
    value={inputString}
    inputProps={{ autoComplete: 'off', style: { textAlign: 'left' } }}
    style={{ direction: 'ltr', minWidth: 0 }}
    onChange={(e) => { setInputString(e.currentTarget.value) }}
    placeholder="Search query"
  />
  <Button color="inherit" onClick={() => { setInputString(''); setHeaderUrls([]); setApiData([]); setSearched(false); setIndex(0); }}><SearchOffIcon /></Button>
</form>

    {loading ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '12px 0' }}>
      <CircularProgress size={20} sx={{ color: accent }} />
      <Typography variant="caption" color="text.secondary">Searching…</Typography>
    </div> : <>
      {searched && <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', py: 0.5 }}>
        {headerUrls.length > 0 ? `${headerUrls.length} results (not yet imported)` : 'No results found'}
      </Typography>}
      <Pagination />
    </>}
    <div ref={scrollRef} style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '6px 0' }}>
      {apiData.length ? apiData.map(item =>
        <HoverPreview externalId={item.externalId} key={item.externalId} style={{ width: 'calc(50% - 3px)' }}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            minHeight: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#e0e0e0',
            cursor: 'pointer'
          }}
          onClick={() => {
            setPreviewItem({
              title: item.meta[0]?.value || '',
              externalId: item.externalId,
              modalUrl: iiifUrl(item.externalId, 30),
            });
          }}
        >
          {!loadedImgs.includes(item.imageUrl) && <CircularProgress size={24} sx={{ position: 'absolute' }} />}
          <img src={item.imageUrl} style={{ width: '100%', display: loadedImgs.includes(item.imageUrl) ? 'block' : 'none', objectFit: 'contain' }}
            onLoad={() => setLoadedImgs(imgs => [...imgs, item.imageUrl])}
            onError={({ currentTarget }) => {
              const retries = parseInt(currentTarget.dataset.retries || '0');
              if (retries >= 3) {
                currentTarget.onerror = null;
                currentTarget.src = "placeholder.png";
                setLoadedImgs(imgs => [...imgs, item.imageUrl]);
              } else {
                currentTarget.dataset.retries = String(retries + 1);
                setTimeout(() => { currentTarget.src = item.imageUrl + '?r=' + retries; }, 2000 * (retries + 1));
              }
            }}
          />
          {loadedImgs.includes(item.imageUrl) && <ImageListItemBar
            sx={{ padding: '0 6px', direction: 'ltr', '& .MuiImageListItemBar-title': { fontFamily: 'sans-serif', fontSize: '12px', textAlign: 'left' } }}
            title={item.meta[0]?.value}
            actionIcon={
              authData?.user?.role === 'admin' ?
              <Tooltip title={importedUrls.includes(item.imageUrl) ? 'Object exists' : 'Import to MAQOM'}>
                <IconButton
                  size="small"
                  style={{ color: importedUrls.includes(item.imageUrl) ? 'white' : '#90ee90' }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    let _data = {}
                    item?.meta.forEach(m => {
                      if (m.label in NLI) {
                        _data[NLI[m.label]] = m.value
                      }
                    })
                    _data['external_id'] = item.externalId
                    _data['mediatype'] = 1
                    _data['image_url'] = iiifUrl(item.externalId, 50)
                    try {
                      let res = await addItem(_data)
                      if (res) {
                        setExistingIds(prev => new Set([...prev, item.externalId]))
                        setApiData(prev => prev.filter(d => d.externalId !== item.externalId))
                      }
                    } catch (err) {
                      if (err?.message?.includes('duplicate') || err?.code === '23505') {
                        setExistingIds(prev => new Set([...prev, item.externalId]))
                        setApiData(prev => prev.filter(d => d.externalId !== item.externalId))
                        alert('Object already exists')
                      } else {
                        console.log(err)
                        alert('Import failed: ' + (err?.message || 'Unknown error'))
                      }
                    }
                  }}>
                  <InputIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              : null
            }
          />}
        </div>
        </HoverPreview>
      )
        :
        null
      }
    </div>
  </Drawer>
  <ExternalPreviewModal open={!!previewItem} onClose={() => setPreviewItem(null)} item={previewItem} />
  </>
}

export default ExternalWidget